import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CommonSearchState } from '../../lib/types/common-search.types';
import { logout } from './authSlice';

const initialState: CommonSearchState = {
  globalQuery: '',
  searchType: 'both',
  isAdvancedSearchOpen: false,
  activeTab: 'people',
  viewMode: 'list',
  recentSearchQueries: [],
  isGlobalSearchActive: false,
};

const searchSlice = createSlice({
  name: 'search',
  initialState,
  reducers: {
    setGlobalQuery: (state, action: PayloadAction<string>) => {
      state.globalQuery = action.payload;
      // Add to recent searches if not empty
      if (action.payload && !state.recentSearchQueries.includes(action.payload)) {
        state.recentSearchQueries.unshift(action.payload);
        // Keep only last 10 recent searches
        state.recentSearchQueries = state.recentSearchQueries.slice(0, 10);
      }
    },
    
    setSearchType: (state, action: PayloadAction<'company' | 'contact' | 'both'>) => {
      state.searchType = action.payload;
    },
    
    setActiveTab: (state, action: PayloadAction<'people' | 'company'>) => {
      state.activeTab = action.payload;
    },
    
    toggleAdvancedSearch: (state) => {
      state.isAdvancedSearchOpen = !state.isAdvancedSearchOpen;
    },
    
    setViewMode: (state, action: PayloadAction<'grid' | 'list'>) => {
      state.viewMode = action.payload;
    },
    
    setGlobalSearchActive: (state, action: PayloadAction<boolean>) => {
      state.isGlobalSearchActive = action.payload;
    },
    
    clearRecentSearches: (state) => {
      state.recentSearchQueries = [];
    },
    
    resetCommonSearchState: (state) => {
      return { ...initialState };
    },
  },
  extraReducers: (builder) => {
    // Client-side routing means the Redux store survives a logout - login
    // cycle, so the global search box's query and active state would
    // otherwise reappear for whoever logs in next - see peopleSlice.ts /
    // companySlice.ts for the same fix on their own filter state.
    builder.addCase(logout.fulfilled, () => ({ ...initialState }));
  },
});

export const {
  setGlobalQuery,
  setSearchType,
  setActiveTab,
  toggleAdvancedSearch,
  setViewMode,
  setGlobalSearchActive,
  clearRecentSearches,
  resetCommonSearchState,
} = searchSlice.actions;

export default searchSlice.reducer;
